import { createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useStore, useAdmin } from './hooks/useData';
import { PoopReport, Settings } from './types';
import Layout from './components/Layout';
import CookieBanner from './components/CookieBanner';
import MapPage from './pages/MapPage';
import AdminPage from './pages/AdminPage';
import MissionPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

interface AppContextType {
  poopReports: PoopReport[];
  activePoopReports: PoopReport[];
  settings: Settings;
  addPoopReport: (report: PoopReport) => void;
  updatePoopReport: (id: string, updates: Partial<PoopReport>) => void;
  deletePoopReport: (id: string) => void;
  updateSettings: (updates: Partial<Settings>) => void;
  isAdmin: boolean;
  login: (password: string) => boolean;
  logout: () => void;
  refresh: () => void;
}

const AppContext = createContext<AppContextType | null>(null);

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be used within AppProvider');
  return ctx;
}

function App() {
  const store = useStore();
  const admin = useAdmin();

  const contextValue: AppContextType = {
    ...store,
    ...admin
  };

  return (
    <AppContext.Provider value={contextValue}>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<MapPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/mission" element={<MissionPage />} />
            <Route path="/about" element={<Navigate to="/mission" replace />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <CookieBanner />
      </BrowserRouter>
    </AppContext.Provider>
  );
}

export default App;
